import { PageLocatorMap } from '../types/PageLocatorMap';

export const applySearchMakePage = {
  alert: {
    error: 'apply-search-make-page.form.alert.error',
  },
  footer: {
    root: 'apply-search-make-page.footer.root',
  },
  form: {
    accessibilitySubmit:
      'apply-search-make-page.form.keyboard-only-submit-button',
    getRadioOption: (index: number): string =>
      `apply-search-make-page.form.radio-option-${index + 1}`,
    h1: 'apply-search-make-page.form.h1',
    h2: 'apply-search-make-page.form.h2',
    radioGroupRoot: 'apply-search-make-page.form.radio-group-root',
    root: 'apply-search-make-page.form.root',
  },
  header: {
    drawerButton: 'apply-search-make-page.header.drawer-button',
    previousStepButton: 'apply-search-make-page.header.previous-step-button',
    root: 'apply-search-make-page.header.root',
  },
  progress: {
    root: 'apply-search-make-page.progress.root',
  },
} as const satisfies PageLocatorMap;
